import gql from 'graphql-tag';

export const CREATE_DEPARTMENT = gql`
  mutation CreateDepartment($input: CreateDepartmentInput!) {
    bpf {
      result: createDepartment(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
